import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { tasksComponent } from './tasks.component';
import { taskActionsComponent } from './task.actions.component';
import { tasksHeaderComponent } from './tasks.header.component';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { DivisionDetailModule } from '../dossiers/components/divisionDetail.module';
import { DossierBasicInfoModule } from '../dossiers/components/dossierBasicInfo.module';
import { TranslateModule } from '@ngx-translate/core';
import { MainPipes } from '../pipes/main-pipes-module';
import { MessageModule } from '../components/message.module';
import { MultiSignatureModule } from './multiSignature/multiSignature.module';
import { tasksListComponent } from './tasksList.component';
import { TableModule } from 'primeng-lts/table';
import { DossierHeaderModule } from '../dossiers/components/dossierHeader.module';
import { DirectivesModule } from '../directives/directives.module';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';
import { ConfirmationService } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { MenuModule } from 'primeng-lts/menu';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TooltipModule } from 'primeng-lts/tooltip';
import { MultiTaskActionModule } from './multiTaskAction/multiTaskAction.module';
import { FormPlycaModule } from '../components/forms/formPlyca.module';
import { DialogModule } from 'primeng-lts/dialog';
import { ChartModule } from 'primeng-lts/chart';
import { DropdownModule } from 'primeng-lts/dropdown';
import { RippleModule } from 'primeng-lts/ripple';


@NgModule({
  declarations: [
    tasksComponent,
    taskActionsComponent,
    tasksHeaderComponent,
    tasksListComponent
  ],
  imports: [
    MainPipes,
    MultiTaskActionModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    FormPlycaModule,
    TableModule,
    TooltipModule,
    DivisionDetailModule,
    DossierHeaderModule,
    MessageModule,
    DossierBasicInfoModule,
    WaitLoadingModule,
    RouterModule,
    PanelModule,
    MenuModule,
    ButtonModule,
    MultiSignatureModule,
    ConfirmDialogModule,
    DirectivesModule,
    MultiSignatureModule,
    ScrollPanelModule,
    SubHeaderModule,
    CheckboxModule,
    OverlayPanelModule,
    ProgressBarModule,
    DialogModule,
    ChartModule,
    DropdownModule,
    RippleModule
  ],
  providers: [ConfirmationService, DialogService],
  exports: [tasksListComponent]
})
export class TasksModule { }
